import React, { useState } from 'react';
import { Button, Popconfirm, Space, Table, TableColumnsType, Tag } from 'antd';
import { useRequest } from 'ahooks';
import { useUpdate } from '@/common/hook';
import { PlusOutlined } from '@ant-design/icons';
import { AuthUserVo, deleteAuth, getAuthList, updateStatus } from '@/api/auth';
import { ProcessListVo } from '@/api/application';
import EditTenant from './editModal';

const columns: TableColumnsType<AuthUserVo> = [
  { title: '租户名称 ', dataIndex: 'tenantName', key: 'tenantName', render: text => text || '-' },
  {
    title: '应用列表',
    dataIndex: 'processList',
    key: 'processList',
    render: text =>
      text
        ?.filter((process: ProcessListVo) => process?.name)
        ?.map((i: ProcessListVo) => i.name)
        .join('、 ') || '-',
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    render: (text: boolean) => <Tag color={text ? 'green' : 'red'}>{text ? '启用' : '禁用'}</Tag>,
  },
];

const ApplicationAuthList = () => {
  const [editData, setEditData] = useState<AuthUserVo>();
  const [visible, setVisible] = useState<boolean>(false);
  const [update, updateFn] = useUpdate();

  const { data: userList, loading } = useRequest(getAuthList, { refreshDeps: [update] });

  const onDelete = (id: number) => {
    deleteAuth(id).then(updateFn);
  };

  const changeStatus = (params: AuthUserVo) => {
    updateStatus({ id: params.id!, status: !params.status }).then(updateFn);
  };

  const buildColumns = [
    ...columns,
    {
      title: '操作',
      key: 'operation',
      render: (_: any, record: AuthUserVo) => (
        <Space size={8}>
          <Button type="link" size="small" style={{ padding: 0 }} onClick={() => changeStatus(record)}>
            {record.status ? '禁用' : '启用'}
          </Button>
          <Button
            type="link"
            size="small"
            style={{ padding: 0 }}
            onClick={() => {
              setEditData(record);
              setVisible(true);
            }}
          >
            编辑
          </Button>
          <Popconfirm title="确定删除该用户？" onConfirm={() => onDelete(record.id!)}>
            <Button type="link" size="small" style={{ padding: 0 }}>
              删除
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Button type="primary" style={{ marginBottom: 10 }} icon={<PlusOutlined />} onClick={() => setVisible(true)}>
        新增授权租户
      </Button>
      <Table<AuthUserVo> columns={buildColumns} dataSource={userList ?? []} loading={loading} />
      {visible && (
        <EditTenant
          data={editData}
          isEdit={!!editData}
          updateFn={updateFn}
          onCancel={() => {
            setVisible(false);
            setEditData(undefined);
          }}
        />
      )}
    </>
  );
};

export default ApplicationAuthList;
